import { authenticationService } from '@/application/services/api-clients/login-service';
import { requestFunnel } from '@/application/api';
import { dateAdd, dateToFormatedString, now } from '@/infrastructure/date';

export class BoletosClient {
  constructor() {
    this.BOLETO_GENERATION_DAY = 22;
    this.BOLETO_KEY = 'Boletos';

    this.axiosRequestConfig = BoletosClient.defaultAxiosRequestConfig();
    this.requestFunnel = requestFunnel;
  }

  async download() {
    const documentKey = this.generateDocumentKey();
    const url = `documents/${documentKey}/boletos`;
    return (await this.requestFunnel.get(url, this.axiosRequestConfig)).data;
  }

  generateDocumentKey() {
    let fetchDate = now('YYYY-MM-DD');
    const [,, day] = fetchDate.split('-');
    if (+day >= this.BOLETO_GENERATION_DAY) {
      fetchDate = dateAdd(fetchDate, 1, 'month');
    }
    fetchDate = dateToFormatedString(fetchDate, 'YYYY-MM');
    return `${this.BOLETO_KEY}-${fetchDate}.csv`;
  }

  static defaultAxiosRequestConfig() {
    return {
      responseType: 'blob',
      headers: authenticationService.authHeader()
    };
  }
}
